import { useMinifiedDispensaries } from './useMinifiedDispensaries';
import { useMuos } from './useMuos';

export const useMinifiedDispensary = (id: string) => {
  const { dispensariesById } = useMinifiedDispensaries();
  const dispensary = dispensariesById[id];

  const { muosById } = useMuos();
  const muo = muosById[id] ?? undefined;

  if (!dispensary && !muo) {
    return undefined;
  }
  return dispensary || muo;
};
